import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-6 pb-4 md:pt-10 md:pb-8 px-4 relative overflow-hidden" data-id="element-93">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-neon/5 rounded-full blur-[120px] pointer-events-none" data-id="element-94" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center gap-3 text-center" data-id="element-96">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black uppercase leading-[1.1] text-white" data-id="element-97">
            Eliminá la Fascitis Plantar en 30 Días y Volvé a Pisar Fuerte —{' '}
            <span className="text-neon" data-id="element-98">
              Sin Plantillas, Sin Kinesiología y Sin Dejar de Entrenar
            </span>
          </h1>

          <p className="text-base md:text-lg text-white max-w-3xl leading-relaxed" data-id="element-99">
            ¿Sabías que el{' '}
            <span className="font-bold" data-id="element-100">94% de los deportistas</span> que sufren
            fascitis plantar están atacando el síntoma equivocado? Lo que te
            duele no es el talón. Es algo que ningún kinesiólogo te explicó — y
            que podés corregir en{' '}
            <span className="font-bold text-neon" data-id="element-101">15 minutos por día</span>{' '}
            desde tu casa.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full flex justify-center my-2" data-id="element-102">
            <video src="https://cdn.magicpatterns.com/uploads/2kEujMVcWJBjPyWGBRns1W/ebook%20video%203.mp4" autoPlay loop muted playsInline className="w-full max-w-md rounded-2xl shadow-[0_0_40px_rgba(212,244,22,0.1)]" data-id="element-103" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}